module.exports = __webpack_public_path__ + "static/media/bg_voice_playb12176d58a73d0b2412f5a9c5e276d1a.webp";